module.exports = __webpack_public_path__ + "img/965185d.gif";